"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChevronDown = function ChevronDown(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("g", {
    clipPath: "url(#clip0)"
  }, _react.default.createElement("path", {
    d: "M19.1183 12.1318C19.0699 12.0834 19.0125 12.0451 18.9493 12.0189C18.8861 11.9927 18.8184 11.9792 18.75 11.9792C18.6816 11.9792 18.6138 11.9927 18.5507 12.0189C18.4875 12.0451 18.43 12.0834 18.3817 12.1318L12.5 18.0135L6.61829 12.1318C6.52061 12.0341 6.38813 11.9792 6.25 11.9792C6.11187 11.9792 5.97939 12.0341 5.88171 12.1318C5.78404 12.2295 5.72916 12.362 5.72916 12.5001C5.72916 12.6382 5.78404 12.7707 5.88171 12.8684L12.1317 19.1184C12.1801 19.1667 12.2375 19.2051 12.3007 19.2313C12.3639 19.2575 12.4316 19.2709 12.5 19.2709C12.5684 19.2709 12.6361 19.2575 12.6993 19.2313C12.7625 19.2051 12.8199 19.1667 12.8683 19.1184L19.1183 12.8684C19.1667 12.82 19.205 12.7626 19.2312 12.6994C19.2574 12.6362 19.2708 12.5685 19.2708 12.5001C19.2708 12.4317 19.2573 12.364 19.2312 12.3008C19.205 12.2376 19.1666 12.1802 19.1183 12.1318Z",
    fill: props.foregroundColor
  })), _react.default.createElement("defs", null, _react.default.createElement("clipPath", {
    id: "clip0"
  }, _react.default.createElement("rect", {
    width: "25",
    height: "25",
    fill: "white"
  }))));
};

ChevronDown.defaultProps = {
  altText: "ChevronDown",
  foregroundColor: "#2D5AB4"
};
ChevronDown.propTypes = {
  altText: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = ChevronDown;
exports.default = _default;